import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Login = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/cont';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" data-testid="login-logo-link">
            <img 
              src="/logo-andeni.png"
              alt="AnDeni Time Solutions"
              className="h-24 w-auto mx-auto mb-8 drop-shadow-lg"
            />
          </Link>
          <h1 className="font-display text-3xl font-bold text-slate-900 mb-3" data-testid="login-title">
            Bine ați venit
          </h1>
          <p className="text-slate-600">
            Conectați-vă pentru a accesa contul dumneavoastră
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-lg border border-slate-200 p-8">
          <Button
            onClick={handleGoogleLogin}
            className="w-full h-12 bg-white border-2 border-slate-200 text-slate-700 hover:bg-slate-50 hover:border-slate-300 gap-3"
            data-testid="google-login-btn"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Continuă cu Google
          </Button>

          <p className="text-sm text-slate-500 text-center mt-6">
            Prin conectare, sunteți de acord cu{' '}
            <Link to="/termeni-conditii" className="text-blue-600 hover:underline">
              Termenii și condițiile
            </Link>
            {' '}și{' '}
            <Link to="/politica-confidentialitate" className="text-blue-600 hover:underline">
              Politica de confidențialitate
            </Link>
            .
          </p>
        </div>

        <p className="text-center text-sm text-slate-500 mt-8">
          <Link to="/" className="text-blue-600 hover:underline" data-testid="back-home-link">
            ← Înapoi la pagina principală
          </Link>
        </p>
      </div>
    </main>
  );
};

export default Login;
